import { Badge } from '@ksyos/design-system';
import type { IPerson } from '@common/utils/getDisplayName';
import { formatString } from '@common/utils/formatString';
import { getDisplayName } from '@common/utils/getDisplayName';
import { getSelectedLanguage } from '@frontend/translate';

interface PendingAccountRequestBadgeProps {
    approverPractitioner: IPerson;
}

export function PendingAccountRequestBadge(props: Readonly<PendingAccountRequestBadgeProps>) {
    const language = getSelectedLanguage();

    return (
        <Badge
            color="neutral"
            size="medium"
            text={formatString(language.organization.pendingApprovalOf, [
                getDisplayName(props.approverPractitioner, false, 'nameGivenNameFamily') || 'Ksyos',
            ])}
        />
    );
}
